<template>
  <div
    id="navbar-others-menu-v2"
    class="others-dropdown-menu cursor-pointer d-flex justify-content-center align-items-center"
    data-title="Menu Lainnya"
  >
    <button class="w-100 h-100 p-0 border-0 bg-transparent" @click="toggleDropdown">
      <font-awesome-icon
        class="activity-icon ellipsis"
        :icon="['fas', 'ellipsis-v']"
      />
    </button>
    <div
      class="dropdown-menu dropdown-menu-right show"
      v-show="isOthersDropdownMenuOpen"
    >
      <a
        v-if="hasProgramStudyGroupActivity"
        id="kelompok-belajar-program-dropdown-menu"
        href="#"
        class="dropdown-item others-drodpown-item inter-medium_small-normal"
        @click.prevent="showProgramGroupActivityModal(), $emit('logEventAnalytic', 'kelompok_click')"
      >
        <img
          class="activity-icon"
          alt="kelompok-belajar-kelas"
          src="https://cdn.karier.mu/assets/v2/icon-activity-kariermu/icon-kelompok-belajar-program-kariermu.svg"
        />
        Kelompok Belajar Program
      </a>
      <a
        v-if="isTanyamu || isMobile"
        id="bagikan-aktivitas-dropdown-menu"
        href="#"
        class="dropdown-item others-drodpown-item inter-medium_small-normal"
        @click="showShareModal"
      >
        <img
          class="activity-icon"
          alt="bagikan-aktivitas"
          src="https://cdn.karier.mu/assets/v2/icon-activity-kariermu/icon-bagikan-kariermu.svg"
        />
        Bagikan Aktivitas
      </a>
      <a
        id="explore-halaman-belajar-dropdown-menu"
        href="#"
        class="dropdown-item others-drodpown-item inter-medium_small-normal s-mt-4"
        @click.prevent="reinitTour"
      >
        <img
          class="activity-icon"
          alt="explore-halaman-belajar"
          src="https://cdn.karier.mu/assets/kariermu/v2/navbar/halaman-belajar/eksplorasi.webp"
        />
        Eksplorasi Halaman Belajar
      </a>
      <a
        id="panduan-dropdown-menu"
        href="https://www.karier.mu/faq/"
        target="_blank"
        class="dropdown-item others-drodpown-item inter-medium_small-normal s-mt-4"
        @click="$emit('logEventAnalytic', 'halaman_belajar_panduan_click')"
      >
        <img
          class="activity-icon"
          src="https://cdn.karier.mu/assets/v2/icon-activity-kariermu/icon-panduan-kariermu.svg"
          alt="bantuan"
        />
        Panduan
      </a>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import activityV2GeneralMixin from '@/mixins/activityV2/general'
import activityV2TourMixin from '@/mixins/activityV2/tour'

export default {
  name: 'OthersDropdownMenu',
  mixins: [activityV2GeneralMixin, activityV2TourMixin],
  props: {
    isTanyamu: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    facilRoomId: {
      type: Number,
      default: 0
    }
  },
  components: {
    FontAwesomeIcon
  },
  data () {
    return {
      isOthersDropdownMenuOpen: false
    }
  },
  computed: {
    hasProgramStudyGroupActivity () {
      return this.$store.state.activityV2.validate.has_program_study_group_activity
    }
  },
  watch: {
    isTourFinished: {
      immediate: true,
      handler (value) {
        if (value) {
          document.addEventListener('click', this.handleClickOutside)
        }
      }
    }
  },
  methods: {
    toggleDropdown () {
      this.isOthersDropdownMenuOpen = !this.isOthersDropdownMenuOpen
      if (this.isOthersDropdownMenuOpen) {
        this.$emit('logEventAnalytic', 'halaman_belajar_kebab_menu_click')
      }
    },
    handleClickOutside (event) {
      if (!this.$el.contains(event.target)) {
        this.isOthersDropdownMenuOpen = false
      }
    },
    showShareModal () {
      this.$emit('showShareModal')
    },
    logEventAnalytic (event) {
      this.$emit('logEventAnalytic', event)
    },
    showProgramGroupActivityModal () {
      this.$store.commit('activityV2/TOGGLE_PROGRAM_GROUP_ACTIVITY_MODAL', true)
    },
    reinitTour () {
      document.removeEventListener('click', this.handleClickOutside)
      this.isOthersDropdownMenuOpen = false
      this.initTour()
    }
  },
  beforeUnmount () {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>

<style lang="scss" scoped>
.others-dropdown-menu {
  position: relative;
  height: 40px;
  width: 40px;
}

.activity-icon.ellipsis {
  color: var(--color-royal-navy-500);
  font-size: 18px;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 20px;
  min-width: 270.59px;
  background: var(--color-ui-element-white-3);
  border: transparent;
  border-radius: 10px;
  box-shadow: 0 16px 20px 1px rgba(51, 51, 51, 0.1);
  display: none;
  padding: 20px 10px;
  z-index: 3;

  &.show {
    display: block;
  }
}

.others-drodpown-item {
  padding: 12px 0 0 0;
  display: flex;
  align-items: center;
  color: var(--color-royal-navy-500);
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }

  .activity-icon {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
}

.dropdown-item {
  padding: 0 30px 0 10px;
}
</style>
